<template>
    <div>
        <select-dropdown
            v-model="filterFields.sourceIds"
            reference="referrer_source"
            label="referrer_source"
            :auto-translate="false"
            multiple
            searchable
            :loading="fetching"
            :options="sources"
            :placeholder="$t('form.dropdown.placeholder')"
            remove-icon
            can-select-all
        ></select-dropdown>
    </div>
</template>

<script>
import * as applications from "../../services/ApplicationService";
import SelectDropdown from "../forms/SelectDropdown";

export default {
    name: 'FilterApplicationSource',
    components: {
        SelectDropdown,
    },
    props: {
        filterFields: {type: Object},
    },
    data() {
        return {
            fetching: true,
            sources: []
        }
    },
    methods: {
        fetch() {
            this.fetching = true;

            applications.sources().then(result => {
                this.sources = result.data;
                this.fetching = false;
            });
        },
    },
    mounted() {
        this.fetch();
    },
}
</script>
